 
 
//
import { NGXLogger } from "ngx-logger";
import { ToolButtonType, IButtonTool } from "../definitions";
import { MapController } from "./map-controller";


import Control from 'ol/control/Control';
import Overlay from 'ol/Overlay';
import VectorLayer from 'ol/layer/Vector';
import Draw from 'ol/interaction/Draw';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import VectorSource from "ol/source/Vector";
import * as olSphere from 'ol/sphere';

    export class MapCtrlMeasure {
        public constructor(public mapCtrl: MapController, private $log : NGXLogger) {

        };

        public addMeasureDistanceButton() {
            this.mapCtrl.measure.distance.button = document.createElement('button');
            this.mapCtrl.measure.distance.button.innerHTML = '<i class="fas fa-ruler-horizontal"></i>';
            this.mapCtrl.measure.distance.button.title = $localize`activează/dezactivează măsurare traseu`;
            $(this.mapCtrl.measure.distance.button).tooltip({placement: "right"});
            this.mapCtrl.measure.distance.buttonCtrl = document.createElement('div');
            this.mapCtrl.measure.distance.buttonCtrl.className = 'measure-distance-button ol-unselectable left-tool-button';
            this.mapCtrl.measure.distance.buttonCtrl.appendChild(this.mapCtrl.measure.distance.button);

            this.mapCtrl.measure.distance.button.addEventListener('click', (event) => { this.onClickMeasureButton(event, ToolButtonType.distance) });
            this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.measure.distance.buttonCtrl);
        }

        public addMeasureAreaButton() {
            this.mapCtrl.measure.area.button = document.createElement('button');
            this.mapCtrl.measure.area.button.innerHTML = '<i class="fas fa-ruler-combined"></i>';
            this.mapCtrl.measure.area.button.title = $localize`activează/dezactivează măsurare suprafețe`;
            $(this.mapCtrl.measure.area.button).tooltip({placement: "right"});
            this.mapCtrl.measure.area.buttonCtrl = document.createElement('div');
            this.mapCtrl.measure.area.buttonCtrl.className = 'measure-area-button ol-unselectable left-tool-button';
            this.mapCtrl.measure.area.buttonCtrl.appendChild(this.mapCtrl.measure.area.button);

            this.mapCtrl.measure.area.button.addEventListener('click', (event) => { this.onClickMeasureButton(event, ToolButtonType.area) });
            this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.measure.area.buttonCtrl);
        }

        public onClickMeasureButton = (event, type) => {
            let button: IButtonTool = this.mapCtrl.measure.distance;
            if (type === ToolButtonType.area) {
                button = this.mapCtrl.measure.area;
            }
            //clear selection
            if (type !== ToolButtonType.distance && this.mapCtrl.measure.distance.buttonStateOn) {
                $(this.mapCtrl.measure.distance.buttonCtrl).removeClass('select-button-on');//
                $(this.mapCtrl.measure.distance.buttonCtrl).removeClass('tool-button-end');
                this.removeMeasureInteraction();
                this.mapCtrl.measure.distance.buttonStateOn = false;
            }
            if (type !== ToolButtonType.area && this.mapCtrl.measure.area.buttonStateOn) {
                $(this.mapCtrl.measure.area.buttonCtrl).removeClass('select-button-on');
                $(this.mapCtrl.measure.area.buttonCtrl).removeClass('tool-button-end');
                this.removeMeasureInteraction();
                this.mapCtrl.measure.area.buttonStateOn = false;
            }
            if (type !== ToolButtonType.select) {

            }
            this.mapCtrl.measure.type = type;
            //
            if (!button.buttonStateOn) {
                $(button.buttonCtrl).addClass('select-button-on');
                //
                this.createMeasureTooltip();
                this.addMeasureLayerInteraction(type);
                //
                button.buttonStateOn = true;
                //remove dragbox and close popover
                //if (this.mapCtrl.selectionExtent) {
                //    this.mapCtrl.map.removeInteraction(this.mapCtrl.selectionExtent);
                //}
                //(this.mapCtrl.infoOverlay as any).hide();
            } else {
                let fet = this.mapCtrl.measure.drawInteraction.getProperties();
                let clean = false;
                if (this.mapCtrl.measure.drawInteraction && this.mapCtrl.measure.drawInteraction.getActive()) {
                    try {
                        this.mapCtrl.measure.drawInteraction.finishDrawing();
                    } catch (e) {
                        this.mapCtrl.measure.drawInteraction.setActive(false);
                        clean = true;
                    }
                } else {
                    clean = true;
                }
                if (clean) {
                    $(button.buttonCtrl).removeClass('select-button-on');
                    $(button.buttonCtrl).removeClass('tool-button-end');
                    this.removeMeasureInteraction();
                    button.buttonStateOn = false;
                }
            }
            //


            //todo
        }

        addMeasureLayerInteraction(type: string) {
            this.mapCtrl.measure.layer = new VectorLayer<any>({
                source: new VectorSource({ wrapX: false })
            });
            this.mapCtrl.map.addLayer(this.mapCtrl.measure.layer);
            let interectionType: any = 'LineString';
            if (type === ToolButtonType.area) {
                interectionType = 'Polygon';
            }
            this.mapCtrl.measure.drawInteraction = new Draw({
                source: this.mapCtrl.measure.layer.getSource(),
                type: interectionType//'LineString',// 'Circle',//'Polygon',
                //geometryFunction: Draw.createBox()
            });
            //
            this.mapCtrl.map.addInteraction(this.mapCtrl.measure.drawInteraction);
            this.mapCtrl.measure.drawInteraction.on('drawend', this.onDrawMeasureEnd);
            this.mapCtrl.measure.drawInteraction.on('drawstart', this.onDrawMeasureStart);
        }

        removeMeasureInteraction() {
            if (this.mapCtrl.measure.layer) {
                this.mapCtrl.map.removeLayer(this.mapCtrl.measure.layer);
                this.mapCtrl.measure.layer = null;
                (this.mapCtrl.infoOverlay as any).hide();
            }
            if (this.mapCtrl.measure.drawInteraction) {
                this.mapCtrl.map.removeInteraction(this.mapCtrl.measure.drawInteraction);
                this.mapCtrl.measure.drawInteraction = null;
            }
            if (this.mapCtrl.measure.tooltipOverlay) {
                this.mapCtrl.map.removeOverlay(this.mapCtrl.measure.tooltipOverlay);
            }
        }

        public onDrawMeasureStart = (event) => {
            this.mapCtrl.measure.layer.getSource().clear();
            (this.mapCtrl.infoOverlay as any).hide();
            //

            //
            let sketch = event.feature as Feature;
            let tooltipCoord = event.coordiante;
            this.mapCtrl.measure.onChangeListener = sketch.getGeometry().on('change', (evt) => {
                var geom = evt.target;
                var output;
                if (geom instanceof Polygon) {
                    output = this.formatArea(geom);
                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                } else if (geom instanceof LineString) {
                    output = this.formatLength(geom);
                    tooltipCoord = geom.getLastCoordinate();
                }
                this.mapCtrl.measure.tooltipElement.innerHTML = output;
                this.mapCtrl.measure.tooltipOverlay.setPosition(tooltipCoord);


            })


        }

        public onDrawMeasureEnd = (event) => {
            let button: IButtonTool = null;
            if (this.mapCtrl.measure.type === ToolButtonType.area) {
                button = this.mapCtrl.measure.area;
            } else if (this.mapCtrl.measure.type === ToolButtonType.distance) {
                button = this.mapCtrl.measure.distance;
            }
            if (button) {
                $(button.buttonCtrl).removeClass('select-button-on');
                $(button.buttonCtrl).addClass('tool-button-end');
            }
            //
            let feature = event.feature as Feature;
            this.mapCtrl.measure.drawInteraction.setActive(false);

        }


        private formatLength(line: LineString) {
            let tmp = line.clone();
            if (this.mapCtrl.mapConfig.projection.toUpperCase() !== 'EPSG:3857') {
                tmp = tmp.transform(this.mapCtrl.mapConfig.projection, 'EPSG:3857') as any;
            }
            var length = (olSphere as any).getLength(tmp);
            var output;
            if (length > 1000) {
                output = (Math.round(length / 1000 * 1000) / 1000) +
                    ' ' + 'km';
            } else {
                output = (Math.round(length * 100) / 100) +
                    ' ' + 'm';
            }
            return output;
        };

        private formatArea(polygon: Polygon) {
            let tmp = polygon.clone();
            if (this.mapCtrl.mapConfig.projection.toUpperCase() !== 'EPSG:3857') {
                tmp = tmp.transform(this.mapCtrl.mapConfig.projection, 'EPSG:3857') as any;
            }
            var area = (olSphere as any).getArea(tmp);
            var output;
            if (area > 1000000) {
                output = (Math.round(area / 1000000 * 1000000) / 1000000) +
                    ' ' + 'km<sup>2</sup>';
            } else {
                output = (Math.round(area * 100) / 100) +
                    ' ' + 'm<sup>2</sup>';
            }
            return output;
        };

        private createMeasureTooltip() {
            if (this.mapCtrl.measure.tooltipElement) {
                this.mapCtrl.measure.tooltipElement.parentNode.removeChild(this.mapCtrl.measure.tooltipElement);
            }
            this.mapCtrl.measure.tooltipElement = document.createElement('div');
            this.mapCtrl.measure.tooltipElement.className = 'tooltip-a tooltip-a-measure';
            this.mapCtrl.measure.tooltipOverlay = new Overlay({
                element: this.mapCtrl.measure.tooltipElement,
                offset: [0, -15],
                positioning: 'bottom-center'
            });
            this.mapCtrl.map.addOverlay(this.mapCtrl.measure.tooltipOverlay);
        }


    }
